var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline_lock",
    "data-name": "outline/lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 16,
    viewBox: "0 0 12.8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-\\u0421olor",
    "data-name": "\\uD83C\\uDFA8-Icon-\\u0421olor",
    d: "M10.4,13.2a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8m0-3.2a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,10.4,10m4.8,5.6a.8.8,0,0,1-.8.8h-8a.8.8,0,0,1-.8-.8V9.2a.8.8,0,0,1,.8-.8h8a.8.8,0,0,1,.8.8ZM8.8,5.289a1.6,1.6,0,1,1,3.2,0V6.8H8.8ZM14.4,6.8h-.8V5.289a3.2,3.2,0,1,0-6.4,0V6.8H6.4A2.4,2.4,0,0,0,4,9.2v6.4A2.4,2.4,0,0,0,6.4,18h8a2.4,2.4,0,0,0,2.4-2.4V9.2a2.4,2.4,0,0,0-2.4-2.4Z",
    transform: "translate(-4 -2)",
    fill: "#0c3058"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineLock);
export default __webpack_public_path__ + "static/media/outline-lock.06ac147e0ea1aeee0618c76211e7dde4.svg";
export { ForwardRef as ReactComponent };